// Local SEO city configs — ultra-local landing pages
const PHONE = "(510) 507-9318";

const COMMON_SERVICES = [
  { key: "gazebo-installer", label: "Gazebo Installation", short: "Gazebo Installer" },
  { key: "pergola-installer", label: "Pergola Installation", short: "Pergola Installer" },
  { key: "costco-gazebo-installer", label: "Costco Gazebo Assembly", short: "Costco Gazebo Installer" },
  { key: "yardistry-installer", label: "Yardistry Installation", short: "Yardistry Installer" },
  { key: null, label: "Sauna Installation", short: "Sauna Installer" },
  { key: null, label: "Playground Assembly", short: "Playground Installer" },
  { key: null, label: "Gym Equipment Installation", short: "Gym Equipment Installer" },
];

export { COMMON_SERVICES };

export const CITY_PAGES = {
  "san-jose": {
    slug: "san-jose",
    name: "San Jose",
    region: "Bay Area, CA",
    state: "California",
    metaTitle:
      "Outdoor Structure Installer in San Jose, CA | Gazebo, Pergola & Sauna Assembly — Xavier Assembly",
    metaDescription:
      "Premium outdoor structure installer in San Jose, CA. Gazebo, pergola, Costco gazebo, Yardistry, sauna, playground & gym equipment installation across South Bay. Free quotes — (510) 507-9318. Contact our team about customer references.",
    keywords:
      "gazebo installer San Jose, pergola installer San Jose, Costco gazebo installer San Jose, Yardistry installer San Jose, sauna installer San Jose, playground assembly San Jose, gym equipment installer San Jose, outdoor structure installation South Bay",
    h1: "Premium Outdoor Structure Installation in San Jose, CA",
    intro:
      "From Willow Glen to Almaden, Cambrian to Berryessa — Xavier Assembly is South Bay's trusted installer for Costco gazebos, Yardistry pergolas, hot saunas, playsets and complete home gyms. We know San Jose's HOA approval process, common backyard substrates, and the brands carried at the Almaden and Coleman Avenue Costcos.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/a889022ea22b0a28830c0305ecf7f6a193a8a980b596ef94d6da1512c702c5af.png",
    neighborhoods: [
      "Willow Glen",
      "Almaden Valley",
      "Cambrian Park",
      "Evergreen",
      "Berryessa",
      "Rose Garden",
      "Santana Row",
      "Silver Creek",
      "Blossom Valley",
      "West San Jose",
    ],
    localPoints: [
      "Share your Costco gazebo model and South Bay installation address so our team can review the required assembly.",
      "Familiar with San Jose HOA approval requirements for outdoor structures over 120 sq ft and 12 ft tall.",
      "Same-day installs available across the Greater San Jose area; most pergolas finished in a single visit.",
      "Bilingual crews — English, Português, Español — serving San Jose's diverse neighborhoods.",
    ],
    faq: [
      {
        q: "How much does gazebo installation cost in San Jose?",
        a: "Most Costco Yardistry gazebo installs in San Jose range from $950 to $2,200 depending on size (10×10, 12×14, 14×16) and substrate. We provide fixed-price written quotes after a quick phone or photo consultation.",
      },
      {
        q: "Do I need a permit for a pergola in San Jose?",
        a: "San Jose typically does not require a building permit for non-attached pergolas under 120 sq ft and not exceeding 12 ft in height — but HOAs often have their own rules. We help you understand which apply to your project.",
      },
      {
        q: "Do you serve Almaden Valley and Willow Glen?",
        a: "Yes — those are two of our most-served neighborhoods. We service the entire San Jose area along with Cambrian, Berryessa, Evergreen, Silver Creek and Blossom Valley.",
      },
    ],
  },

  sacramento: {
    slug: "sacramento",
    name: "Sacramento",
    region: "California",
    state: "California",
    metaTitle:
      "Sacramento Outdoor Structure Installer | Gazebo, Pergola & Yardistry Assembly — Xavier Assembly",
    metaDescription:
      "Trusted gazebo installer, pergola installer & Yardistry assembly service in Sacramento, CA. We install Costco gazebos, saunas, playsets and gym equipment across Sacramento Valley. Free quotes — (510) 507-9318.",
    keywords:
      "gazebo installer Sacramento, pergola installer Sacramento, Costco gazebo installer Sacramento, Yardistry installer Sacramento, sauna installer Sacramento, playground assembly Sacramento, outdoor structure installation Sacramento Valley",
    h1: "Sacramento's Trusted Outdoor Structure Installer",
    intro:
      "Sacramento summers demand serious shade. Whether you're in East Sac, Land Park, Natomas or Elk Grove, Xavier Assembly installs the gazebos, pergolas and outdoor saunas that turn your backyard into a year-round retreat — built to handle 100°F summers and Valley winters.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/76772547beac3bdc032dcb9cdf38a4a1f6137e70b86a207645f8adca44da3ef4.png",
    neighborhoods: [
      "East Sacramento",
      "Land Park",
      "Natomas",
      "Pocket-Greenhaven",
      "Elk Grove",
      "Roseville",
      "Folsom",
      "Rocklin",
      "Citrus Heights",
      "Carmichael",
    ],
    localPoints: [
      "Sacramento Valley heat dictates anchoring & UV-grade hardware — we spec the right finishes for our climate.",
      "We pick up directly from the Sacramento and Folsom Costcos and install same-day in most cases.",
      "Experienced with Yardistry, Sojag, Sunjoy and TOJA Grid pergolas common in Sacramento neighborhoods.",
      "Free travel from our Bay Area HQ — Sacramento Valley is a top-3 market for our crews.",
    ],
    faq: [
      {
        q: "Will my gazebo handle Sacramento summer heat?",
        a: "Yes — all the Yardistry and Sojag SKUs we install are rated for high UV and heat. We use stainless and zinc-plated hardware in Sacramento installs to prevent corrosion from heat cycling.",
      },
      {
        q: "Do you install in Roseville, Folsom and Elk Grove?",
        a: "Absolutely — those are all within our regular Sacramento service area, no extra travel charge.",
      },
      {
        q: "Can I get an install done before a summer party?",
        a: "Yes — we routinely book Sacramento installs within 7–10 days. Call (510) 507-9318 and we'll do our best to match your timeline.",
      },
    ],
  },

  concord: {
    slug: "concord",
    name: "Concord",
    region: "Bay Area, CA",
    state: "California",
    metaTitle:
      "Concord, CA Outdoor Structure Installer | Gazebo, Pergola, Sauna — Xavier Assembly",
    metaDescription:
      "Premium outdoor structure installer in Concord, CA. Gazebo installer, pergola installer, Yardistry & Costco gazebo assembly, sauna installation and gym setup across the Diablo Valley. (510) 507-9318.",
    keywords:
      "gazebo installer Concord, pergola installer Concord, Costco gazebo installer Concord CA, Yardistry installer Diablo Valley, sauna installer Concord, gym equipment installer Concord, outdoor structure Concord",
    h1: "Concord & Diablo Valley Outdoor Structure Specialists",
    intro:
      "Concord is our backyard — literally. We accept gazebo, pergola and outdoor sauna installation requests across Concord, Walnut Creek, Pleasant Hill and Clayton. Ask our team about customer references and availability for your project.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/6ae90a625581d82e34bdcd4f696e22ea4fe3ffc55c29abea2a2c3734569f9ceb.png",
    neighborhoods: [
      "Downtown Concord",
      "Dana Estates",
      "Crystyl Ranch",
      "Pleasant Hill",
      "Walnut Creek",
      "Clayton",
      "Martinez",
      "Pittsburg",
      "Antioch",
      "Pacheco",
    ],
    localPoints: [
      "Concord is one of our top three markets — fast scheduling, sometimes same-week.",
      "We routinely pick up Costco gazebos from the Concord Costco and deliver direct.",
      "Familiar with Crystyl Ranch and Dana Estates HOA outdoor-structure requirements.",
      "Bilingual crews — English, Português, Español.",
    ],
    faq: [
      {
        q: "Do you offer free pickup from the Concord Costco?",
        a: "Yes — we offer optional Costco pickup as an add-on across the Concord/Walnut Creek area. Add it to your install and you skip the truck rental.",
      },
      {
        q: "How quickly can you install in Concord?",
        a: "For standard 10×12 or 12×14 Yardistry gazebos, we usually have availability within 5–10 days. Larger pergolas with electrical 2–3 weeks.",
      },
      {
        q: "Do you install in Clayton and Martinez?",
        a: "Yes — both are within our regular Diablo Valley service area, no extra travel charge.",
      },
    ],
  },

  vacaville: {
    slug: "vacaville",
    name: "Vacaville",
    region: "California",
    state: "California",
    metaTitle:
      "Vacaville Outdoor Structure Installer | Gazebo & Pergola Assembly — Xavier Assembly",
    metaDescription:
      "Outdoor assembly quote requests in Vacaville. Premium gazebo installer, pergola installer, Yardistry & Costco gazebo assembly, sauna and gym equipment installation. Free quotes — (510) 507-9318.",
    keywords:
      "gazebo installer Vacaville, pergola installer Vacaville, Costco gazebo installer Vacaville, Yardistry installer Vacaville, sauna installer Vacaville, outdoor structure installer Solano County",
    h1: "Outdoor Structure Installation in Vacaville",
    intro:
      "Vacaville is home. From Browns Valley to North Orchard, we accept requests for gazebo, pergola, sauna, playset and home gym assembly. Our team reviews your product, site and requested scope before confirming availability.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/0e18d599926d52d1c310172f23265e32cc0bb1a37c21f7d4ee36469143cdb97c.png",
    neighborhoods: [
      "Browns Valley",
      "North Orchard",
      "Cheyenne",
      "Foxboro",
      "Cambridge",
      "Marshall",
      "Cherry Glen",
      "Lagoon Valley",
      "Fairfield",
      "Dixon",
    ],
    localPoints: [
      "Ask our team about customer references and similar projects in Vacaville.",
      "Vacaville HQ-area — our fastest scheduling and most-installed market.",
      "Familiar with every HOA requirement in Browns Valley, North Orchard, Cheyenne and Foxboro.",
      "Project-specific quotes after a review of your product and installation site.",
    ],
    faq: [
      {
        q: "Can I ask about similar projects in Vacaville?",
        a: "Yes. Contact our team with your product model and project details to ask about relevant experience and available customer references.",
      },
      {
        q: "What's your typical Vacaville scheduling time?",
        a: "Most Vacaville installs are scheduled within 3–7 days of quote approval. We prioritize our home market.",
      },
      {
        q: "Do you also install in Fairfield and Dixon?",
        a: "Yes — Fairfield and Dixon are part of our regular Solano County service area at no extra travel charge.",
      },
    ],
  },

  modesto: {
    slug: "modesto",
    name: "Modesto",
    region: "Central Valley, CA",
    state: "California",
    metaTitle:
      "Modesto Outdoor Structure Installer | Gazebo, Pergola, Sauna Assembly — Xavier Assembly",
    metaDescription:
      "Modesto premium gazebo installer, pergola installer and Yardistry assembly service. We install Costco gazebos, saunas, playsets and gym equipment across Stanislaus County. (510) 507-9318.",
    keywords:
      "gazebo installer Modesto, pergola installer Modesto, Costco gazebo installer Modesto, Yardistry installer Modesto, sauna installer Modesto, playground assembly Modesto, outdoor structure installer Stanislaus County",
    h1: "Modesto's Premium Outdoor Structure Installer",
    intro:
      "Central Valley summers and big backyards make Modesto a perfect canvas for premium outdoor structures. Xavier Assembly installs gazebos, pergolas and outdoor saunas across Modesto, Turlock, Riverbank and Ceres — built to handle Stanislaus County heat and last for decades.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/a889022ea22b0a28830c0305ecf7f6a193a8a980b596ef94d6da1512c702c5af.png",
    neighborhoods: [
      "Downtown Modesto",
      "La Loma",
      "College Area",
      "Sherwood Forest",
      "Village One",
      "Salida",
      "Riverbank",
      "Ceres",
      "Turlock",
      "Oakdale",
    ],
    localPoints: [
      "Heat-rated hardware and finishes for Central Valley 100°F+ summers.",
      "We service the Modesto Costco and deliver direct to your site.",
      "Larger Central Valley lots — we install bigger 14×16 pavilions and full home gym setups regularly.",
      "Bilingual crews — English, Português, Español.",
    ],
    faq: [
      {
        q: "Will my gazebo survive Modesto summers?",
        a: "Yes — every install uses UV-stable hardware and we recommend the right Yardistry or Sojag SKU for our heat. We also offer optional cedar staining/sealing for hardwood structures.",
      },
      {
        q: "Do you serve Turlock, Ceres and Riverbank?",
        a: "Yes — all part of our standard Modesto-area service zone, no trip surcharges.",
      },
      {
        q: "What's your turnaround time in Modesto?",
        a: "Most Modesto installs are scheduled within 7–14 days, depending on season. Summer books up fast — call early.",
      },
    ],
  },

  "santa-rosa": {
    slug: "santa-rosa",
    name: "Santa Rosa",
    region: "North Bay, CA",
    state: "California",
    metaTitle:
      "Santa Rosa Outdoor Structure Installer | Gazebo, Pergola, Wine Country Patio — Xavier Assembly",
    metaDescription:
      "Premium gazebo installer, pergola installer and Yardistry assembly service in Santa Rosa, CA. Wine Country backyard structures, saunas, playsets and gym setups installed with precision. (510) 507-9318.",
    keywords:
      "gazebo installer Santa Rosa, pergola installer Santa Rosa, Costco gazebo installer Santa Rosa, Yardistry installer Sonoma County, sauna installer Santa Rosa, outdoor structure installer North Bay",
    h1: "Wine Country Pergola & Gazebo Installation — Santa Rosa, CA",
    intro:
      "Santa Rosa and the Sonoma County wine country call for backyard structures that look as good as the view. Xavier Assembly installs aluminum and cedar pergolas, custom gazebos, outdoor saunas and complete patio setups for Santa Rosa, Petaluma, Windsor, Healdsburg and Rohnert Park homes.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/76772547beac3bdc032dcb9cdf38a4a1f6137e70b86a207645f8adca44da3ef4.png",
    neighborhoods: [
      "Bennett Valley",
      "Fountaingrove",
      "Skyhawk",
      "Oakmont",
      "West End",
      "Petaluma",
      "Windsor",
      "Healdsburg",
      "Rohnert Park",
      "Sebastopol",
    ],
    localPoints: [
      "Experienced with Sonoma County's micro-climates — we spec stainless hardware for coastal humidity.",
      "Familiar with wildfire-rebuild rebuild backyards in Fountaingrove and Coffey Park.",
      "Cedar pergolas + outdoor kitchens — our top requested combo in Wine Country.",
      "Servicing Petaluma, Windsor and Healdsburg as standard service area.",
    ],
    faq: [
      {
        q: "Do you work in Healdsburg and Sebastopol?",
        a: "Yes — Healdsburg, Sebastopol, Windsor and Petaluma are all part of our standard Sonoma County service area.",
      },
      {
        q: "Can you build to look custom rather than kit-like?",
        a: "Yes — pre-staining, hidden hardware, beam wrapping, integrated LED, ceiling fan support. The Wine Country aesthetic is one of our specialties.",
      },
      {
        q: "Do you offer fire-rebuild-friendly outdoor structures?",
        a: "Yes — we install aluminum pergolas and metal-roofed gazebos which meet Sonoma County's WUI (wildland-urban interface) preferences. Ask for our rebuild-friendly SKU list.",
      },
    ],
  },

  "bay-area": {
    slug: "bay-area",
    name: "Bay Area",
    region: "California",
    state: "California",
    metaTitle:
      "Bay Area Outdoor Structure Installer | Premium Gazebo, Pergola & Sauna Assembly — Xavier Assembly",
    metaDescription:
      "Premium Bay Area gazebo installer and pergola installer. Serving San Francisco, Oakland, San Jose, Fremont, Walnut Creek, Concord and the entire Bay. Yardistry, Costco, sauna, playground & gym installation. (510) 507-9318.",
    keywords:
      "gazebo installer Bay Area, pergola installer Bay Area, Costco gazebo installer Bay Area, Yardistry installer San Francisco Bay, sauna installer Bay Area, outdoor structure installer East Bay, premium outdoor structure installation",
    h1: "Bay Area Premium Outdoor Structure Installation",
    intro:
      "From Marin to South Bay, East Bay to the Peninsula — Xavier Assembly is the Bay's premium outdoor structure installer. We accept requests for gazebo, pergola, sauna and playset installations across San Francisco, Oakland, San Jose, Fremont, Walnut Creek, Concord and beyond.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/a889022ea22b0a28830c0305ecf7f6a193a8a980b596ef94d6da1512c702c5af.png",
    neighborhoods: [
      "San Francisco",
      "Oakland",
      "Berkeley",
      "San Jose",
      "Fremont",
      "Walnut Creek",
      "Concord",
      "Pleasanton",
      "Palo Alto",
      "Redwood City",
      "Mountain View",
      "Marin",
    ],
    localPoints: [
      "We cover all 9 Bay Area counties — Alameda, Contra Costa, Marin, Napa, San Francisco, San Mateo, Santa Clara, Solano and Sonoma.",
      "Familiar with strict Bay Area HOA and city permitting (San Francisco, Berkeley, Palo Alto have unique rules).",
      "Specialty: small-yard pergolas and rooftop deck installs for SF / Oakland row houses.",
      "English, Português and Español. Ask our team about customer references in the Bay Area.",
    ],
    faq: [
      {
        q: "Do you serve the entire Bay Area?",
        a: "Yes — all 9 Bay Area counties. Our crews dispatch daily across the region. Travel is included in your quote.",
      },
      {
        q: "Can you install on a small SF backyard or rooftop?",
        a: "Yes — we have specific experience installing pergolas and small gazebos in San Francisco's narrow backyards and on Bay Area rooftop decks.",
      },
      {
        q: "Where do you base out of?",
        a: "We dispatch from the East Bay and travel throughout the region. No trip charges for any Bay Area zip code.",
      },
    ],
  },

  reno: {
    slug: "reno",
    name: "Reno",
    region: "Nevada",
    state: "Nevada",
    metaTitle:
      "Reno, NV Outdoor Structure Installer | Gazebo, Pergola, Yardistry Assembly — Xavier Assembly",
    metaDescription:
      "Reno's trusted outdoor structure installer. Gazebo installer, pergola installer, Costco gazebo & Yardistry assembly, sauna installation, playset assembly and gym equipment installer across Northern Nevada. (510) 507-9318.",
    keywords:
      "gazebo installer Reno, pergola installer Reno, Costco gazebo installer Reno NV, Yardistry installer Northern Nevada, sauna installer Reno, playground assembly Reno, gym equipment installer Reno, outdoor structure installer Sparks NV",
    h1: "Reno & Northern Nevada Outdoor Structure Installer",
    intro:
      "Reno's high desert means strong sun, hot summers and real snow loads. Xavier Assembly installs gazebos, pergolas and outdoor saunas spec'd specifically for Northern Nevada — aluminum frames, reinforced roof loads, anchored against high winds. Serving Reno, Sparks, Carson City and Lake Tahoe.",
    heroImage:
      "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/0e18d599926d52d1c310172f23265e32cc0bb1a37c21f7d4ee36469143cdb97c.png",
    neighborhoods: [
      "Old Southwest",
      "Caughlin Ranch",
      "Somersett",
      "ArrowCreek",
      "Damonte Ranch",
      "Spanish Springs",
      "Sparks",
      "Carson City",
      "Incline Village",
      "South Lake Tahoe",
    ],
    localPoints: [
      "Reno's snow loads matter — we spec aluminum pergolas with higher snow ratings and reinforced hardwood pavilions.",
      "High-desert UV is brutal on cheap hardware — every Reno install uses stainless or zinc-plated fasteners.",
      "Our team confirms local availability and the insurance documentation required for your installation before scheduling.",
      "We travel to Reno regularly from the Bay Area — flat travel built into your quote, no surprises.",
    ],
    faq: [
      {
        q: "Will my gazebo handle Reno snow?",
        a: "Yes — we recommend Yardistry's stronger Meridian and Cambridge SKUs, or aluminum pergolas with reinforced roof spans. We'll spec the right product for your zip code's snow load rating.",
      },
      {
        q: "Do you also install in Sparks and Carson City?",
        a: "Yes — Sparks, Carson City and the Lake Tahoe basin are all part of our regular Reno service area.",
      },
      {
        q: "Are you insured in Nevada?",
        a: "Ask our team to confirm the insurance documentation applicable to your Nevada installation and any requirements from your HOA in Somersett, ArrowCreek or Caughlin Ranch before scheduling.",
      },
    ],
  },
};

export const CITY_LIST = Object.values(CITY_PAGES);
export const PHONE_NUMBER = PHONE;
